import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ReservationService } from "../../../service/reservation.service";
import { Reservation } from "src/app/model/reservation.model";
import { SportType } from "src/app/model/sport-type.model";
import { SkillLevel } from "src/app/model/skill-level.model";
import { LessonType } from "src/app/model/lesson-type.model";
import { Location } from "@angular/common";
import { AuthService } from "src/app/service/auth.service";
import { User } from "src/app/model/user.model";
import { Role } from "src/app/model/role.model";

@Component({
  selector: "app-reservation-process",
  templateUrl: "./reservation-process.component.html",
  styleUrls: ["./reservation-process.component.css"]
})
export class ReservationProcessComponent implements OnInit {
  reservation: Reservation;
  reservationListOrEquipment: String;

  constructor(
    private reservationService: ReservationService,
    private activedRoute: ActivatedRoute,
    private router: Router,
    private location: Location,
    public authService: AuthService
  ) {
    if (this.router.getCurrentNavigation().extras.state) {
      this.reservationListOrEquipment = this.router.getCurrentNavigation().extras.state.reservationListOrEquipment as String;
    }
  }

  ngOnInit() {
    this.getReservation();
  }

  getReservation() {
    this.activedRoute.params.subscribe(params => {
      this.reservationService
        .getByIdWithItems(params.id)
        .subscribe(data => (this.reservation = data as Reservation));
      });
  }

  back() {
    if(this.reservationListOrEquipment=='reservationList'){
      if(this.authService.currentUserIsAdmin){
        this.router.navigateByUrl('/reservation-list', { state: { isLessonReservation: this.reservation.isLessonReservation } });
      }
      else{
        this.router.navigateByUrl('/profile', { state: { isLesson: this.reservation.isLessonReservation } });
      }
    }
    else if(this.reservationListOrEquipment=='equipment')
    {
      this.router.navigateByUrl('/schedule-equipment'); 
    }
    else{
      this.location.back();
    }
  /*   this.location.back(); */
  }
}
